import React from "react";
import { Task } from "../../../models/Task";
import { useTask } from "../../../contexts/TaskContext";
import { Table, TableBody } from "../../../design/table";
import { Heading, Subheading } from "../../../design/heading";
import TaskListItem from "../../../components/TaskComponent/components/TaskListItem";
import TaskButton from "../../../components/TaskButton";
import { Card } from "../../../design/card";
import { Button } from "../../../design/button";
import { Text } from "../../../design/text";
import ParentingPlanStatusBadge from "../../../components/Badges/ParentingPlanStatusBadge";
import { useParentingPlan } from "../../../contexts/ParentingPlanContext";
import moment from "moment";
import ParentingPlanButton from "../../../components/ParentingPlanButton";
import { useCustodyEvent } from "../../../contexts/CustodyEventContext";
import { useMatter } from "../../../contexts/MatterContext";
import { useVisitationSchedule } from "../../../contexts/VisitationScheduleContext";
import CreateVisitationScheduleButton from "../../../components/CreateVisitationScheduleButton/CreateVisitationScheduleButton";
import { useNavigate } from "react-router-dom";

interface Props {}

const NextExchangeComponent: React.FC<Props> = ({}) => {
  const { partiesInvolved } = useMatter();
  const { custodyEvents } = useCustodyEvent();
  const { currentVisitationSchedule } = useVisitationSchedule();
  const navigate = useNavigate();

  const currentEvent = custodyEvents.find((event) => {
    const start = moment(`${event.startDate}T${event.startTime}`);
    const end = moment(`${event.endDate}T${event.endTime}`);
    return moment().isSameOrAfter(start) && moment().isBefore(end);
  });

  const nextExchange = {
    date: currentEvent?.endDate,
    time: currentEvent?.endTime,
    with: partiesInvolved.find((p) => p._id === currentEvent?.participantId)
      ?.name,
  };

  if (!currentVisitationSchedule) {
    return (
      <Card>
        <Heading level={5}>Next Exchange</Heading>
        <Text>No visitation schedule or holidy plan available.</Text>
        <CreateVisitationScheduleButton
          onSave={(id) => navigate(`/visitation-schedule/${id}`)}
        />
      </Card>
    );
  }

  return (
    <Card>
      <Heading level={5}>Next Exchange</Heading>
      <Text>
        {nextExchange.date} at {nextExchange.time}
      </Text>
      <Text className="text-sm text-gray-500">With: {nextExchange.with}</Text>
    </Card>
  );
};

export default NextExchangeComponent;
